<template>
  <div class="container-main-body">
    <!--按钮开始-->
    <div class="list-container">
      <div v-if="searchShow" class="search-container">
        <el-row>
          <el-col :span="6">
            <div class="search-form-label">托盘号：</div>
            <div class="search-form-controller">
              <el-input
                size="mini"
                placeholder="托盘号"
                clearable
                v-model="queryData.PT"
              ></el-input>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align: center;">
            <el-button
              type="warning"
              size="mini"
              icon="el-icon-search"
              plain
              @click="searchHandler"
              >开始搜索</el-button
            >
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-delete"
              plain
              @click="searchHandler('clear')"
              >清空</el-button
            >
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-close"
              plain
              @click="showSearchHandler()"
              >关闭搜索</el-button
            >
          </el-col>
        </el-row>
      </div>
      <div class="list-btns-container">
        <el-button-group>
          <el-button
            v-for="btn in $store.state.currentLBtnList"
            :key="btn.id"
            :type="btn.button_type"
            size="mini"
            :icon="btn.button_icon"
            @click="handlerButtonDispatch(btn.fn)"
            >{{ btn.button_name }}</el-button
          >
          <el-autocomplete
            style="margin-left: 20px"
            size="mini"
            popper-class="my-autocomplete"
            v-model="queryData.sampleName"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入样本册"
            @select="handleSelect"
            @blur="handblur"
          >
            <i
              class="el-icon-edit el-input__icon"
              slot="suffix"
              @click="handleIconClick"
            >
            </i>
            <template slot-scope="{ item }">
              <span>{{ item.name }}</span>
            </template>
          </el-autocomplete>
        </el-button-group>
      </div>
      <!--按钮结束-->
      <!--列表数据 开始-->
      <div class="el-table-container">
        <el-table
          :data="ds"
          size="mini"
          stripe
          border
          height="100%"
          style="width: 100% border:1px solid #d1d1d1"
          header-row-class-name="list-header-row"
          row-class-name="list-row"
        >
          <el-table-column
            label="样本册"
            prop="sampleName"
            width="170"
            align="center"
          ></el-table-column>
          <el-table-column
            label="托盘号"
            prop="pt"
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            label="册/箱"
            prop="volumesPerCarton"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="箱/PT"
            prop="cartons"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="册数"
            prop="volumes"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="日期"
            prop="createDateStr"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="时间"
            prop="createTimeStr"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column></el-table-column>
          <el-table-column label="操作" width="60" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-view"
                circle
                plain
                @click.stop.prevent="viewHandler(scope.row)"
              ></el-button>
            </template>
          </el-table-column>
          <el-table-column label="删除" width="60" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button
                type="danger"
                size="mini"
                icon="el-icon-delete-solid"
                circle
                plain
                @click.stop.prevent="deleteHandler(scope.row)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-container">
        <el-pagination
          background
          :current-page="queryData.pn"
          :page-size="queryData.pageSize"
          :total="queryData.totalCount"
          :page-sizes="[10, 15, 20, 25, 30, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChange"
          @current-change="pageChange"
        ></el-pagination>
      </div>
    </div>
    <!--列表数据 结束-->
    <!-- 新增表单对话框 -->
    <print-note-form ref="DForm" :parent="this" />
  </div>
</template>

<script>
import PrintNoteForm from "@/views/modules/makebook/printnote/Form";
export default {
  data: function() {
    return {
      ds: [],
      queryData: {
        PT: "",
        sampleName: "",
        pn: 1, // 页码
        pageSize: 20, // 每页条数
        totalCount: 0 // 数据总条数
      },
      searchShow: false,
      operator_id: sessionStorage.getItem("operator_id")
    };
  },
  created: function() {},
  mounted: function() {
    this.loadProduct();
  },
  methods: {
    // 按钮 点击 调度方法
    handlerButtonDispatch: function(fn, args) {
      var _this = this;
      if (typeof _this[fn] === "function") {
        _this[fn].apply(_this, args);
      } else {
        console.log("warning: the method is not exist");
      }
    },
    // 样本册搜索
    loadProduct: function() {
      let _this = this;
      _this.get(_this.$apis.getInstoreProduct, {}, function(res) {
        _this.productList = res.data.dataList;
      });
    },
    querySearchAsync: function(queryString, cb) {
      this.product_check = "false";
      var results = queryString
        ? this.productList.filter(this.createStateFilter(queryString))
        : this.productList;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 500 * Math.random());
    },
    createStateFilter: function(queryString) {
      return product => {
        return product.name.indexOf(queryString) > -1;
      };
    },
    handleSelect: function(item) {
      let _this = this;
      _this.product_check = "true";
      _this.queryData.sampleName = item.name;
      _this.loadData();
    },
    handleIconClick: function(ev) {
      console.log(ev);
    },
    handblur: function() {
      if (this.product_check === "false") {
        this.queryData.sampleName = "";
      }
    },
    // 加载数据
    loadData: function() {
      if(this.queryData.sampleName === '') {
        this.$message.error('请选择样本册')
        return;
      }
      let _this = this;
      _this.post(_this.$apis.getProductPrintNoteList, this.queryData, function(
        res
      ) {
        let _json = res.data;
        if (_json.status && _json.status === "logout") {
          _this.logout();
        } else {
          _this.ds = _json.datalist;
          _this.queryData.totalCount = _json.totalCount;
        }
      });
    },
    // 新增
    addHandler: function() {
      this.$refs.DForm.addHandler();
    },
    // 浏览
    viewHandler: function(_row) {
      let formId = _row.id;
      this.$refs.DForm.viewHandler(formId);
    },
    //删除
    deleteHandler: function(_row){
      let _this = this;
      
      _this
          .$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            let _params = {
              id: _row.id
            };
            // ajax提交至服务器，删除数据
            _this.post(_this.$apis.delNotes, _params, function(res) {
              let _json = res.data;
              if (_json.status === "ok") {
                _this.loadData();
                _this.$message({
                  type: "success",
                  message: "删除成功!"
                });
              } else {
                _this.$message({
                  type: "error",
                  message: "无数据更新!"
                });
              }
            });
          })
          .catch(() => {
            _this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
    },
    searchHandler: function(_type) {
      this.queryData.pn = 1;
      if (_type === "clear") {
        this.queryData.PT = "";
      }
      this.loadData();
    },
    showSearchHandler: function() {
      this.searchShow = !this.searchShow;
    },
    // 刷新事件
    refreshHandler: function() {
      this.loadData();
    },
    // 页码改变
    pageSizeChange: function(pageSize) {
      this.queryData.pn = 1;
      this.queryData.pageSize = pageSize;
      this.loadData();
    },
    pageChange: function(pn) {
      this.queryData.pn = pn;
      this.loadData();
    }
  },
  components: {
    PrintNoteForm
  }
};
</script>
